import { fromJS } from 'immutable';
import 'jspolyfill-array.prototype.findIndex';
import * as types from '../constants';
import { configJson } from '../common/rcs_gaz_mc_core_FE/common/config';
import {
  checkCompetitionsRows,
  clearAvailableSports,
  emptyCompetitions,
  filterMatches, liveCompetitionsCounter, sortSportsPosition, updateAvailableSports,
} from '../utils/sports';

const initialState = fromJS({
  availableSports: configJson.filterBar.sports || [],
  sortedSports: [],
  error: {},
  competitions: {},
  highlightedCompetitions: {},
  filteredCompetitions: {},
  filteredHighlightedCompetitions: {},
  allSports: true,
  availableSportsCounter: 0,
  selectedSportsCounter: 0,
  liveCompetitionsCounter: 0,
  live: false,
  filterDate: configJson.dictionary.it.filterBar.dropdown[1],
  loaded: false,
  loadedAll: {},
  promohighlighted: [],
  liveSoccerMatches: 0,
});


export default function sportsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_SPORTS_LIST_SUCCESS: {
      return state.delete('highlightedCompetitions')
        .delete('filteredHighlightedCompetitions')
        .set('loaded', true);
    }
    case types.SET_PROMO_HIGHLIGHTED: {
      return state.set('promohighlighted', fromJS(action.promohighlighted));
    }
    case types.SET_AVAILABLE_SPORT: {
      const { isAvailable, sortingPosition, sportId } = action.sport;
      const { REACT_APP_SITE } = process.env;

      if ((sportId === '8' || sportId === '6C' || sportId === '6M') && (REACT_APP_SITE === 'fcinter' || REACT_APP_SITE === 'calcionapoli1926' || REACT_APP_SITE === 'forzaroma')) {
        return state;
      }

      const idx = state.get('availableSports')
        .findIndex(avSport => (avSport.get('id') === sportId));
      if (idx < 0) return state;

      const sortedSport = state.getIn(['availableSports', idx]);

      return state.setIn(['availableSports', idx, 'isAvailable'], isAvailable)
        .update('sortedSports', arr => arr.push(
          sortedSport
            .set('sortingPosition', sortingPosition)
            .set('isAvailable', isAvailable),
        ))
        .update('availableSportsCounter', counter => (isAvailable ? counter + 1 : counter));
    }
    case types.SORT_SPORTS_LIST: {
      return state.update('sortedSports', arr => arr.sort((a, b) => sortSportsPosition(a.toJS(), b.toJS())));
    }
    case types.FILTER_DATETIME: {
      return state.set('availableSports', initialState.get('availableSports'))
        .set('sortedSports', initialState.get('sortedSports'))
        .set('allSports', true)
        .set('selectedSportsCounter', 0)
        .set('loaded', false)
        .set('availableSportsCounter', 0);
    }
    case types.FILTER_DATETIME_SUCCESS: {
      return state.set('filterDate', fromJS(action.date));
    }
    case types.FILTER_SPORT: {
      const idSport = action.sportId;
      const idx = state.get('sortedSports').findIndex(item => item.get('id') === idSport);
      if (idx < 0) {
        return state.set('availableSports', updateAvailableSports(state.get('availableSports'), idSport))
          .set('allSports', false);
      }
      return state.set('availableSports', updateAvailableSports(state.get('availableSports'), idSport))
        .set('sortedSports', updateAvailableSports(state.get('sortedSports'), idSport))
        .set('allSports', false);
    }
    case types.GET_COMPETITIONS_LIST_REQUEST: {
      const sportId = action.sportId.toString();
      return state.setIn(['loadedAll', sportId, 'isLoaded'], false);
    }
    case types.SET_COMPETITION_LOADED: {
      const sportId = action.sportId.toString();
      return state.setIn(['loadedAll', sportId, 'isLoaded'], true);
    }
    case types.GET_COMPETITIONS_LIST_SUCCESS: {
      const sortedData = filterMatches(JSON.parse(JSON.stringify(action.data)), false);
      const soccerCounter = liveCompetitionsCounter(state.get('competitions'), '1') + liveCompetitionsCounter(state.get('highlightedCompetitions'), '1');
      return state.deleteIn(['competitions', action.sportId])
        .deleteIn(['filteredCompetitions', action.sportId])
        .setIn(['competitions', action.sportId], fromJS(emptyCompetitions(sortedData, action.sportId)))
        .set('loaded', true)
        .set('liveSoccerMatches', soccerCounter);
    }
    case types.GET_HIGHLIGHTED_COMPETITIONS_LIST_SUCCESS: {
      const filteredCompetitions = fromJS(emptyCompetitions(filterMatches(action.data, true), action.sportId));
      return state.deleteIn(['highlightedCompetitions', action.sportId])
        .setIn(['highlightedCompetitions', action.sportId], filteredCompetitions);
    }
    case types.FILTER_ALL_SPORTS: {
      return state.set('allSports', true)
        .set('availableSports', clearAvailableSports(state.get('availableSports')))
        .set('sortedSports', clearAvailableSports(state.get('sortedSports')));
    }
    case types.FILTER_LIVE:
      return state.set('filteredCompetitions', checkCompetitionsRows(state, action.live, 'competitions'))
        .set('filteredHighlightedCompetitions', checkCompetitionsRows(state, action.live, 'highlightedCompetitions'))
        .set('live', action.live)
        .set('liveCompetitionsCounter', liveCompetitionsCounter(state.get('competitions')) + liveCompetitionsCounter(state.get('highlightedCompetitions')));

    case types.SET_FAVOURITES_COMPETITIONS_LIST:
      return state.set('filteredCompetitions', checkCompetitionsRows(state, state.get('live'), 'competitions'))
        .set('filteredHighlightedCompetitions', checkCompetitionsRows(state, state.get('live'), 'highlightedCompetitions'));

    case types.CLEAR_SORTED_SPORTS:
      return state.set('sortedSports', initialState.get('sortedSports'));

    default:
      return state;
  }
}
